import { createSlice, PayloadAction } from '@reduxjs/toolkit'; 

// ---------------
 
interface PaywallState {
  isSelectedPlan: boolean,
}

// ---------------

const initialState: PaywallState = {
  isSelectedPlan: false, 
};

// ---------------


export const paywallSlice = createSlice({

  name: 'paywall',

  initialState,

  reducers: {

    setIsSelectedPlan: (state, action: PayloadAction<boolean>) => { 

        state.isSelectedPlan = action.payload; 

    },
    resetPaywall: (state) => { 
        
      state.isSelectedPlan = false; 

    } 

  },

}); 

// ---------------

export const { 
  setIsSelectedPlan, 
  resetPaywall 
} = paywallSlice.actions;

export default paywallSlice.reducer;